/*
  C4 / Print.App / Print Options glue.

  Print Options owns options, price, quantity and add-to-cart, verified server-side.
  Print.App owns design identity, editor lifecycle and the production files.

  ONE PRESS, TWO LINES. An artwork plan is CHOSEN in the plan panel, not bought there: the
  panel writes a pending plan onto the product form and this file adds it to the cart in the
  same action as the print job -- plan first, then the configurator's own Add to cart is
  forwarded. Before this, choosing a plan added a cart line immediately, so the cart held a
  design service for a job that might never be ordered and the PDP total counted money the
  customer had not committed to.

  IF THE PLAN LINE FAILS, THE PRINT JOB IS NOT ADDED EITHER. Half an order is worse than none:
  a print job with no design service looks complete and quietly is not. The customer is told
  and nothing is added.

  THE PRICE IS STATED THREE TIMES AND ALWAYS AGREES: the block at the top, the total bar at
  the foot of the configurator, and the Add to cart button. The bar exists because the options
  are tall enough that the top price scrolls away before the artwork choice, and people were
  scrolling up and back to check the cost. It shows the plan as its own line so nobody thinks
  the print price rose.

  NO SUMMARY COLUMN: the app's own is hidden and its grid track collapsed (note 7m).

  CUSTOMER ARTWORK BECOMES THE FIRST GALLERY THUMBNAIL. Any property holding an image URL is
  picked up, whichever control wrote it. Uploaded thumbnails carry an x that dispatches
  c4:artwork-remove; the upload card owns the property and does the removing. The design
  thumbnail has none: clearing a design destroys work and reloads the page, so it keeps its
  confirm on the card.

  PDF, AI AND EPS ARE RASTERISED BY CLOUDINARY (f_jpg,pg_1) and every derived URL is PROBED
  before it is shown, so an account with PDF/EPS delivery off shows no thumbnail rather than a
  broken one.

  THE DESIGN PREVIEW COMES FROM PRINT.APP'S app:saved EVENT (Print.App support, 17 Sep 2026:
  "listen to app:saved and in the payload, you will obtain the preview"). The payload's
  data.previews is an array of {url} objects, one per page (verified on a real save: CloudFront
  PNGs). The first page fills the shared [data-c4-design-preview] slot. After a reload the same
  payload is read back from Print.App's own localStorage entry (print-app-sp), but only when its
  projectId matches the project currently in properties[_printapp]; an empty _printapp means no
  design, so the slot is emptied.

  THE HEARTBEAT BACKS OFF: 500ms while things move, doubling to 6s after four unchanged ticks,
  reset by any real signal, idle while the tab is hidden.

  PALETTE: black #101112, blue-teal #04A7A7, light neutrals (confirmed 9 Sep 2026). Text on a teal fill is
  black. See c4-pdp.css.
*/
(function () {
  'use strict';

  var DESIGN_LABEL = 'Design it online';
  var LOADER_MAX_H = 72;
  var PINNED = 'data-c4-pinned';
  var DROP = 0.88, DROP_MIN = 520, DROP_MAX = 1200;

  var QUICK_MS = 500;
  var IDLE_MAX_MS = 6000;
  var CALM_TICKS = 4;

  var HIDE_SUMMARY_COLUMN = true;
  var HIDE_SUMMARY_ADD = true;
  var VENDOR_TYPE_SCALE = true;
  var SHOW_TOTAL_BAR = true;

  var CLOUDINARY = /res\.cloudinary\.com\/[^/]+\/image\/upload\//i;
  var RASTERISE = /\.(pdf|ai|eps)(\?|#|$)/i;
  var DERIVE = 'f_jpg,pg_1,q_auto,w_1200/';

  var VENDOR_HOST = /print\.app|pitchprint/i;
  var MONEY = /^([A-Z]{0,3})\s*\$\s*([\d,]+\.\d{2})$/;
  var IMGISH = /\.(png|jpe?g|webp|gif|svg)(\?|#|$)/i;

  var DESIGN_ACTIONS = {
    resume: /resume|continue design|edit (my )?design/i,
    clear: /clear design|remove design|delete design|clear artwork/i,
    create: /personalis|personaliz|create design|start design|design (it |now)/i
  };

  var probes = {};
  var onProbe = null;

  var memo = {};
  function cached(key, fn) {
    if (!(key in memo)) memo[key] = fn();
    return memo[key];
  }

  function text(el) { return (el.textContent || '').replace(/\u00a0/g, ' ').trim(); }

  function injectVendorStyles() {
    if (!VENDOR_TYPE_SCALE || document.getElementById('c4-vendor-type')) return;
    var s = document.createElement('style');
    s.id = 'c4-vendor-type';
    s.textContent =
      '.c4-apps{font-size:14px;line-height:1.45}' +
      '.c4-apps [data-c4-hidden]{display:none!important}' +
      '.c4-thumb-x{position:absolute;top:2px;right:2px;z-index:4;width:22px;height:22px;display:flex;' +
      'align-items:center;justify-content:center;padding:0;border:1px solid #dcdcd9;border-radius:50%;' +
      'background:rgba(255,255,255,.94);color:#3c3e3e;font:700 13px/1 system-ui,sans-serif;cursor:pointer;' +
      'box-shadow:0 2px 6px rgba(16,17,18,.16)}' +
      '.c4-thumb-x:hover{background:#fff;color:#b3261e;border-color:#b3261e}' +
      '.c4-total{display:flex;flex-wrap:wrap;gap:6px 16px;align-items:baseline;justify-content:space-between;' +
      'border:2px solid var(--c4-ink,#101112);border-radius:12px;padding:12px 15px;background:#fff}' +
      '.c4-total__k{font:700 10.5px/1 system-ui,sans-serif;letter-spacing:.12em;text-transform:uppercase;color:#5a5d5d}' +
      '.c4-total__v{font:800 22px/1 system-ui,sans-serif;letter-spacing:-.03em;color:#101112}' +
      '.c4-total__n{flex:1 1 100%;margin:0;font:500 11.5px/1.45 system-ui,sans-serif;color:#7d8080}';
    document.head.appendChild(s);
  }

  function probe(url) {
    if (!url) return 'bad';
    if (probes[url]) return probes[url];
    probes[url] = 'pending';
    var im = new Image();
    im.onload = function () { probes[url] = 'ok'; if (onProbe) onProbe(); };
    im.onerror = function () { probes[url] = 'bad'; if (onProbe) onProbe(); };
    im.src = url;
    return 'pending';
  }

  function form() {
    return document.querySelector('#c4-product-form') || document.querySelector('form[action*="/cart/add"]');
  }

  function deepAll(root, sel) {
    var out = [], seen = 0;
    (function walk(node) {
      if (!node || !node.querySelectorAll || seen > 80) return;
      seen++;
      var hits = node.querySelectorAll(sel);
      for (var i = 0; i < hits.length; i++) out.push(hits[i]);
      var all = node.querySelectorAll('*');
      for (var j = 0; j < all.length; j++) if (all[j].shadowRoot) walk(all[j].shadowRoot);
    })(root);
    return out;
  }

  function inside(container, el) {
    if (!container || !el) return false;
    var n = el;
    while (n) {
      if (n === container) return true;
      n = n.parentNode || null;
      if (n && n.nodeType === 11 && n.host) n = n.host;
    }
    return false;
  }

  function labelOf(el) { return (el.textContent || el.value || '').trim(); }
  function isC4(el) {
    var c = el.className;
    return typeof c === 'string' && c.indexOf('c4-') !== -1;
  }
  function ownedByC4(el) {
    if (el.nodeType !== 1) return true;
    if (el.tagName === 'INPUT' || el.tagName === 'NOSCRIPT' || el.tagName === 'STYLE' || el.tagName === 'SCRIPT') return true;
    return isC4(el);
  }

  function looksLikeLoader(el) {
    if (el.querySelector('button, a, input, select, textarea, [role="button"]')) return false;
    var h = el.scrollHeight;
    return h > 0 && h <= LOADER_MAX_H;
  }
  function loaderTop(apps) {
    var drop = apps.offsetHeight * DROP;
    if (drop < DROP_MIN) drop = Math.min(DROP_MIN, Math.max(apps.offsetHeight - 40, 0));
    if (drop > DROP_MAX) drop = DROP_MAX;
    return apps.offsetTop + drop;
  }
  function pin(el, top) {
    if (!el.hasAttribute(PINNED)) {
      el.setAttribute(PINNED, '');
      el.dataset.c4PrevStyle = el.getAttribute('style') || '';
      el.style.position = 'absolute';
      el.style.left = '0';
      el.style.right = '0';
      el.style.zIndex = '2';
      el.style.pointerEvents = 'none';
    }
    var want = Math.round(top) + 'px';
    if (el.style.top !== want) el.style.top = want;
  }
  function unpin(el) {
    if (!el.hasAttribute(PINNED)) return;
    el.removeAttribute(PINNED);
    var prev = el.dataset.c4PrevStyle || '';
    if (prev) { el.setAttribute('style', prev); } else { el.removeAttribute('style'); }
    delete el.dataset.c4PrevStyle;
  }
  function sweep(f, apps) {
    var top = loaderTop(apps);
    var kids = Array.prototype.slice.call(f.children);
    for (var i = 0; i < kids.length; i++) {
      var el = kids[i];
      if (el === apps) break;
      if (ownedByC4(el)) continue;
      if (looksLikeLoader(el)) { pin(el, top); } else { unpin(el); }
    }
  }

  function setHidden(el, on) {
    if (!el) return;
    if (on) {
      if (el.hasAttribute('data-c4-hidden')) return;
      el.setAttribute('data-c4-hidden', '');
      el.dataset.c4HidPrev = el.getAttribute('style') || '';
      el.style.setProperty('display', 'none', 'important');
    } else if (el.hasAttribute('data-c4-hidden')) {
      el.removeAttribute('data-c4-hidden');
      var prev = el.dataset.c4HidPrev || '';
      if (prev) { el.setAttribute('style', prev); } else { el.removeAttribute('style'); }
      delete el.dataset.c4HidPrev;
    }
  }

  function allControls(f) {
    return cached('controls', function () {
      return deepAll(f, 'button, input[type="submit"], a, [role="button"]');
    });
  }

  function vendorAddButton(f, apps) {
    return cached('addBtn', function () {
      var els = allControls(f);
      for (var i = 0; i < els.length; i++) {
        if (!inside(apps, els[i])) continue;
        if (/add to cart/i.test(labelOf(els[i]))) return els[i];
      }
      return null;
    });
  }

  function summaryHead(apps) {
    return cached('head', function () {
      var els = deepAll(apps, '*'), head = null;
      for (var i = 0; i < els.length; i++) {
        if (!/^summary$/i.test(text(els[i]))) continue;
        if (head && head.contains(els[i])) { head = els[i]; continue; }
        if (!head) head = els[i];
      }
      return head;
    });
  }

  function summaryColumn(apps) {
    return cached('column', function () {
      var head = summaryHead(apps);
      if (!head) return null;
      var node = head;
      while (node.parentElement && node.parentElement !== apps && inside(apps, node.parentElement)) {
        var p = node.parentElement;
        var d = getComputedStyle(p).display;
        if ((d === 'grid' || d === 'flex') && p.children.length > 1) return { col: node, row: p, display: d };
        node = p;
      }
      return null;
    });
  }

  function hideSummaryColumn(apps) {
    var found = summaryColumn(apps);
    if (!found) return;
    setHidden(found.col, HIDE_SUMMARY_COLUMN);
    if (found.display !== 'grid') return;
    if (HIDE_SUMMARY_COLUMN) {
      if (!found.row.hasAttribute('data-c4-row')) {
        found.row.setAttribute('data-c4-row', '');
        found.row.dataset.c4RowPrev = found.row.getAttribute('style') || '';
      }
      found.row.style.setProperty('grid-template-columns', 'minmax(0,1fr)', 'important');
    } else if (found.row.hasAttribute('data-c4-row')) {
      found.row.removeAttribute('data-c4-row');
      var prev = found.row.dataset.c4RowPrev || '';
      if (prev) { found.row.setAttribute('style', prev); } else { found.row.removeAttribute('style'); }
      delete found.row.dataset.c4RowPrev;
    }
  }

  function vendorTotal(apps) {
    return cached('total', function () {
      var els = deepAll(apps, '*'), best = null, bestVal = -1, cur = '';
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.children.length) continue;
        var t = text(el);
        if (t.length > 24) continue;
        var m = t.match(MONEY);
        if (!m) continue;
        var v = parseFloat(m[2].replace(/,/g, ''));
        if (v > bestVal) { bestVal = v; best = t; cur = m[1]; }
      }
      return best ? { text: best, cents: Math.round(bestVal * 100), prefix: cur } : null;
    });
  }

  function money(cents, prefix) {
    var s = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (prefix || '') + '$' + s;
  }

  /* Written by the plan chooser. Not a line item property: it is an instruction for the add,
     not something the order should carry. */
  function pendingPlan() {
    var f = form();
    var el = f && f.querySelector('[data-c4-plan-pending]');
    if (!el || !el.value) return null;
    try { return JSON.parse(el.value); } catch (e) { return null; }
  }
  function clearPendingPlan() {
    var f = form();
    var el = f && f.querySelector('[data-c4-plan-pending]');
    if (el) el.value = '';
  }

  function syncPrice(apps) {
    var cell = document.querySelector('.c4-price [data-c4-price]');
    if (!cell) return;
    var t = vendorTotal(apps);
    if (!t) return;
    if (cell.textContent !== t.text) cell.textContent = t.text;
  }

  function ensureTotalBar(apps) {
    if (!SHOW_TOTAL_BAR) return null;
    var bar = document.querySelector('[data-c4-total]');
    if (bar) return bar;
    if (!apps || !apps.parentNode) return null;
    bar = document.createElement('div');
    bar.className = 'c4-total';
    bar.setAttribute('data-c4-total', '');
    bar.hidden = true;
    bar.innerHTML =
      '<span class="c4-total__k">Your total</span>' +
      '<span class="c4-total__v" data-c4-total-v></span>' +
      '<p class="c4-total__n" data-c4-total-n>inc GST</p>';
    apps.parentNode.insertBefore(bar, apps.nextSibling);
    return bar;
  }

  function syncTotalBar(apps) {
    var bar = ensureTotalBar(apps);
    if (!bar) return;
    var t = vendorTotal(apps);
    if (!t) { bar.hidden = true; return; }

    bar.hidden = false;
    var plan = pendingPlan();
    var planCents = plan ? plan.cents : 0;
    var v = bar.querySelector('[data-c4-total-v]');
    var n = bar.querySelector('[data-c4-total-n]');
    var wantV = money(t.cents + planCents, t.prefix);
    var wantN = planCents
      ? 'inc GST \u00b7 ' + money(t.cents, t.prefix) + ' print + ' + money(planCents, t.prefix) + ' ' +
        plan.name.toLowerCase() + ' artwork plan'
      : 'inc GST \u00b7 updates as you configure';
    if (v.textContent !== wantV) v.textContent = wantV;
    if (n.textContent !== wantN) n.textContent = wantN;
  }

  /* STICKY CART BAR -- Direction A (Cathy, 14 Sep 2026: "I am also missing the sticky cart at the
     bottom"). Product thumbnail, title, live price with "inc GST · pickup <day>", and an Add to
     cart button, fixed to the bottom of the viewport at EVERY width once the in-page button has
     scrolled out of view. A proxy of the proxy: it never submits; it clicks the page's own button,
     so every rule that button enforces (price ready, Apippa hand-back, the drawer) still applies.
     Quote-state pages have no add button, so they get no bar. */
  function addButton(f) {
    return f.querySelector('[data-c4-proxy-add]') || f.querySelector('[data-c4-basic-add]');
  }
  function ensureSticky(f) {
    var bar = document.querySelector('[data-c4-sticky]');
    if (bar) return bar;
    var btn = addButton(f);
    if (!btn) return null;
    var title = f.getAttribute('data-c4-product-title') || document.title.split('|')[0].trim();
    var main = document.querySelector('[data-c4-main]');
    var thumb = main && main.getAttribute('src') ? main.getAttribute('src') : '';
    bar = document.createElement('div');
    bar.className = 'c4-sticky';
    bar.setAttribute('data-c4-sticky', '');
    bar.innerHTML =
      (thumb ? '<img class="c4-sticky__img" data-c4-sticky-img src="' + thumb + '" alt="" width="56" height="56" loading="lazy" decoding="async">' : '') +
      '<div class="c4-sticky__meta">' +
        '<div class="c4-sticky__t" data-c4-sticky-t></div>' +
        '<div class="c4-sticky__v" data-c4-sticky-v>\u2014</div>' +
        '<div class="c4-sticky__n"><span data-c4-sticky-n>inc GST</span><span class="c4-rate" data-c4-sticky-rate hidden></span></div>' +
      '</div>' +
      '<button type="button" class="c4-sticky__btn" data-c4-sticky-btn disabled>Add to cart</button>';
    bar.querySelector('[data-c4-sticky-t]').textContent = title;
    document.body.appendChild(bar);
    document.body.classList.add('c4-has-sticky');
    bar.querySelector('[data-c4-sticky-btn]').addEventListener('click', function () {
      var live = addButton(f);
      if (live && !live.disabled) live.click();
    });
    if (window.IntersectionObserver) {
      new IntersectionObserver(function (entries) {
        bar.setAttribute('data-c4-btn-visible', entries[0].isIntersecting ? '1' : '0');
        syncSticky(f);
      }, { threshold: 0.01 }).observe(btn);
    } else {
      bar.setAttribute('data-c4-btn-visible', '0');
    }
    return bar;
  }

  function pickupText() {
    /* The buy box's own "Ready for pickup" readout: second column of .c4-price, bold line. */
    var col = document.querySelector('.c4-price > div:last-child');
    var line = col && col.children[1];
    var t = line ? String(line.textContent || '').trim() : '';
    return t ? 'pickup ' + t : '';
  }

  function syncSticky(f) {
    var bar = ensureSticky(f);
    if (!bar) return;
    var btn = addButton(f);
    var ready = !!(btn && !btn.disabled);
    var below = bar.getAttribute('data-c4-btn-visible') === '0';
    var on = ready && below;
    if (bar.classList.contains('is-on') !== on) bar.classList.toggle('is-on', on);
    var sb = bar.querySelector('[data-c4-sticky-btn]');
    if (sb && sb.disabled === ready) sb.disabled = !ready;
    var v = bar.querySelector('[data-c4-sticky-v]');
    var t = document.querySelector('[data-c4-total-v]');
    /* Print Options publishes a running total; legacy products have no such block, so fall back
       to whatever the price block currently shows (c4-legacy.js keeps that in step with Apippa).
       Without the fallback the bar reads "—" on every legacy product. */
    var price = document.querySelector('.c4-price [data-c4-price]');
    var want = (t && t.textContent) ? t.textContent.trim()
             : ((price && price.textContent) ? price.textContent.trim() : '\u2014');
    if (v && v.textContent !== want) v.textContent = want;
    var n = bar.querySelector('[data-c4-sticky-n]');
    var pk = pickupText();
    var wantN = 'inc GST' + (pk ? ' \u00b7 ' + pk : '');
    if (n && n.textContent !== wantN) n.textContent = wantN;
    /* The thumbnail follows the stage, so the bar shows the customer's own artwork once chosen. */
    var img = bar.querySelector('[data-c4-sticky-img]');
    var main = document.querySelector('[data-c4-main]');
    if (img && main && main.getAttribute('src') && img.getAttribute('src') !== main.getAttribute('src')) img.setAttribute('src', main.getAttribute('src'));
  }

  function bindBottomAdd(f, apps) {
    var btn = f.querySelector('[data-c4-proxy-add]');
    var vendor = vendorAddButton(f, apps);
    var ready = !!vendor;

    hideSummaryColumn(apps);
    setHidden(vendor, HIDE_SUMMARY_ADD && ready);

    if (!btn) return;
    if (!btn.hasAttribute('data-c4-bound')) {
      btn.setAttribute('data-c4-bound', '');
      btn.addEventListener('click', function () {
        memo = {};
        var live = vendorAddButton(f, apps);
        if (!live) return;
        var plan = pendingPlan();

        if (!plan) { live.click(); return; }

        /* Plan first, print second, one press. If the plan fails, nothing is added: a print
           job with no design service looks complete and quietly is not. */
        document.dispatchEvent(new CustomEvent('c4:working', {
          detail: { title: 'Adding to your cart', body: 'Your print job and the ' + plan.name.toLowerCase() + ' artwork plan.' }
        }));

        var props = { 'For': document.title };
        var brief = f.querySelector('input[name="properties[Design brief]"]');
        if (brief && brief.value) props['Brief'] = brief.value.slice(0, 500);
        var link = f.querySelector('input[name="properties[Reference link]"]');
        if (link && link.value) props['Reference link'] = link.value;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: plan.id, quantity: 1, properties: props }] })
        }).then(function (r) {
          if (!r.ok) throw new Error('plan add failed');
          return r.json();
        }).then(function () {
          clearPendingPlan();
          document.dispatchEvent(new CustomEvent('c4:done'));
          vendorAddButton(f, apps) && vendorAddButton(f, apps).click();
        }).catch(function () {
          document.dispatchEvent(new CustomEvent('c4:working', {
            detail: {
              title: 'Nothing was added',
              body: 'The artwork plan could not be added, so we did not add the print job either. Try again, or call us on ' + (f.getAttribute('data-c4-phone') || '1300 247 746') + '.'
            }
          }));
          setTimeout(function () { document.dispatchEvent(new CustomEvent('c4:done')); }, 6000);
        });
      });
    }
    var note = f.querySelector('[data-c4-proxy-note]');
    if (btn.disabled === ready) {
      btn.disabled = !ready;
      btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      btn.style.opacity = ready ? '' : '0.72';
      if (note) note.hidden = ready;
    }
    var label = 'Add to cart';
    if (ready) {
      var t = vendorTotal(apps);
      var plan = pendingPlan();
      if (t) label = 'Add to cart \u00b7 ' + money(t.cents + (plan ? plan.cents : 0), t.prefix);
    }
    if (btn.textContent !== label) btn.textContent = label;
  }

  /* PRINT OPTIONS NOW OWNS THE DESIGNER LAUNCH (found 17 Sep 2026). Print.App's client hides its
     own Personalise / Resume / Clear buttons whenever a Print Options widget on the page offers the
     designer as an artwork route (PrintAppClient.setCommandPref: `options.offersProducer`). On
     product.c4 that leaves no vendor button for the design card to forward to, so "Customise" never
     appeared. When no vendor button exists, the card calls the editor client directly:
     showApp() opens the editor, clearDesign() fires app:project:reset, which Print.App's Shopify
     loader answers by clearing its storage and reloading the page. Vendor buttons still win when
     they exist. */
  function printAppClient() {
    var c = window.printAppInstance;
    return c && typeof c.showApp === 'function' ? c : null;
  }

  function designButtons(f, apps, card) {
    return cached('designBtns', function () {
      var els = allControls(f), found = { create: null, resume: null, clear: null, all: [] };
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (inside(apps, el) || inside(card, el) || isC4(el)) continue;
        var t = labelOf(el);
        if (!t) continue;
        var kind = null;
        if (DESIGN_ACTIONS.resume.test(t)) kind = 'resume';
        else if (DESIGN_ACTIONS.clear.test(t)) kind = 'clear';
        else if (DESIGN_ACTIONS.create.test(t)) kind = 'create';
        if (!kind) continue;
        if (!found[kind]) found[kind] = el;
        found.all.push(el);
      }
      return found;
    });
  }

  function propertyFields() {
    return cached('props', function () {
      var out = [], all = deepAll(document, 'input, textarea, select');
      for (var i = 0; i < all.length; i++) {
        var n = all[i].name || '';
        if (n.indexOf('properties[') !== 0) continue;
        if (all[i].type === 'radio' && !all[i].checked) continue;
        if (all[i].type === 'checkbox' && !all[i].checked) continue;
        out.push(all[i]);
      }
      return out;
    });
  }

  function designInputs() {
    return cached('designInputs', function () {
      var out = [], all = deepAll(document, 'input, textarea');
      for (var i = 0; i < all.length; i++) if (/printapp/i.test(all[i].name || '')) out.push(all[i]);
      return out;
    });
  }

  function projectId() {
    return cached('project', function () {
      var ins = designInputs();
      for (var i = 0; i < ins.length; i++) {
        var n = (ins[i].name || '').toLowerCase(), v = (ins[i].value || '').trim();
        if (n.indexOf('pdf') !== -1) continue;
        if (v && v.indexOf('http') !== 0) return v;
      }
      for (var j = 0; j < ins.length; j++) {
        var m = (ins[j].value || '').match(/(project_[0-9a-f-]{36})/i);
        if (m) return m[1];
      }
      return null;
    });
  }

  function hasDesign() { return !!projectId(); }

  /* A Print.App preview entry is {url: "https://..."}; accept a bare string too, in case the
     payload shape changes. */
  function previewOf(p) {
    var u = p && (typeof p === 'string' ? p : p.url);
    return u && /^https?:\/\//i.test(u) ? u : null;
  }

  function fillDesignSlot(url) {
    var el = document.querySelector('[data-c4-design-preview]');
    var want = url || '';
    if (el && el.value !== want) el.value = want;
  }

  /* EVERY SIDE OF THE DESIGN, NOT JUST THE FIRST (Cathy, 17 Sep 2026: "a business card usually has
     2 sides but only 1 side is presenting in the gallery"). Print.App's payload carries one preview
     per page; all of them become "Yours" thumbnails, labelled Front and Back when there are two. */
  function pagesOf(list) {
    var out = [];
    for (var i = 0; list && i < list.length; i++) {
      var u = previewOf(list[i]);
      if (u && out.indexOf(u) === -1) out.push(u);
    }
    return out;
  }

  var savedPages = { id: null, urls: [] };

  /* Print.App keeps each product's last saved payload in localStorage['print-app-sp'], keyed by
     product id. Only trust an entry whose projectId is the project on this form. */
  function storedPrintAppPages() {
    var pid = projectId();
    if (!pid) return [];
    if (savedPages.id === pid && savedPages.urls.length) return savedPages.urls;
    try {
      var sp = JSON.parse(window.localStorage.getItem('print-app-sp') || '{}');
      for (var k in sp) {
        var e = sp[k];
        if (e && e.projectId === pid && e.previews && e.previews.length) return pagesOf(e.previews);
      }
    } catch (err) {}
    return [];
  }

  /* PitchPrint (legacy template): c4-pitchprint.js writes page 1 only,
     https://pitchprint.io/previews/<projectId>_1.jpg. PitchPrint's own session store
     (localStorage['pprint-sp'], per product) records numPages for the project, so the other sides
     are the same URL with _2, _3 ... Each is probed before it is shown. */
  function pitchPrintPages(first) {
    var m = first && first.match(/^(https?:\/\/pitchprint\.io\/previews\/)([^\/?#]+)_1\.jpg(\?[^#]*)?$/i);
    if (!m) return first ? [first] : [];
    var id = m[2];
    try { id = decodeURIComponent(m[2]); } catch (err) {}
    var n = 1;
    try {
      var sp = JSON.parse(window.localStorage.getItem('pprint-sp') || '{}');
      for (var k in sp) {
        /* PitchPrint stores each product's record as a url-encoded JSON string. */
        var e = sp[k];
        if (typeof e === 'string') { try { e = JSON.parse(decodeURIComponent(e)); } catch (err2) { e = null; } }
        if (e && e.projectId === id && e.numPages) n = Math.max(n, parseInt(e.numPages, 10) || 1);
      }
    } catch (err) {}
    /* Keep the ?v= save stamp from c4-pitchprint.js on every page: PitchPrint rewrites the same
       filenames on each save, and the stamp is what makes the browser fetch the new pictures. */
    var out = [];
    for (var i = 1; i <= Math.min(n, 12); i++) out.push(m[1] + m[2] + '_' + i + '.jpg' + (m[3] || ''));
    return out;
  }


  /* ONE window.onmessage SLOT, TWO VENDORS (found 17 Sep 2026). Print.App's client listens to its
     editor with `window.onmessage = this.handleMsg.bind(this)`, a single assignment rather than
     addEventListener. PitchPrint's store-level script loads on every product page, Print.App ones
     included, and assigns `window.onmessage` too ("bound _handleMsg"). Whichever loads last owns
     the slot. When PitchPrint wins, the Print.App editor's messages are dropped: Customise leaves an
     invisible editor over the page (the editor's handshake never lands, so the show stays pending),
     and Submit saves nothing (app:saved arrives and nobody handles it). It was intermittent because
     it depends on load order.
     The guard forwards Print.App editor messages to the Print.App client whenever the slot is NOT
     Print.App's own handler, so a message is never handled twice and never lost. The real fix is
     PitchPrint not loading on Print.App products (store-level app embed, Cathy's call). */
  function guardPrintAppMessages() {
    if (window.__c4PaMsgGuard) return;
    window.__c4PaMsgGuard = true;
    window.addEventListener('message', function (e) {
      var C = window.PrintAppClient;
      var inst = window.printAppInstance;
      var frame = (C && C.ENDPOINTS && C.ENDPOINTS.frameDomain) || 'https://editor.print.app';
      if (!inst || typeof inst.handleMsg !== 'function' || e.origin !== frame) return;
      /* PRINT.APP FIXED THEIR SIDE (18 Sep 2026, from this report): the client now listens with
         addEventListener and keeps the bound handler on `onMessage`, so it can no longer be
         displaced. When that property is there the guard stands down -- forwarding as well would
         handle every message twice. It only does anything for the old single-slot client. */
      if (inst.onMessage) return;
      var slot = window.onmessage;
      if (slot && slot.name === 'bound handleMsg') return;
      inst.handleMsg(e);
    });
  }

  /* window.printAppInstance is created by Print.App's Shopify loader after its client script
     loads, so poll for it briefly. */
  function hookPrintAppSaved(wake) {
    var tries = 0;
    (function look() {
      var inst = window.printAppInstance;
      if (inst && typeof inst.addEventListener === 'function') {
        if (inst.__c4SavedHook) return;
        inst.__c4SavedHook = true;
        inst.addEventListener('app:saved', function (value) {
          var data = value && value.data;
          var urls = pagesOf(data && data.previews);
          if (urls.length) {
            savedPages = { id: (data && data.projectId) || null, urls: urls };
            fillDesignSlot(urls[0]);
          }
          memo = {};
          setTimeout(wake, 60);
        });
        return;
      }
      if (++tries < 60) setTimeout(look, 500);
    })();
  }

  /* The shared design-preview slot (snippets/c4-artwork-design-card.liquid). PitchPrint fills it
     on the legacy template; Print.App will fill it here once it exposes a preview key. Either way
     the URL becomes the first, non-removable gallery thumbnail through artworkUrls(). */
  function designSlotUrl() {
    var el = document.querySelector('[data-c4-design-preview]');
    var v = el && (el.value || '').trim();
    return v && v.indexOf('http') === 0 ? v : null;
  }

  function designPreviews() {
    /* Print.App products (the .c4-apps route only: Print.App's store-level loader can also run on
       legacy PitchPrint pages, and must not empty their slot): the project input decides. No project,
       no preview (a cleared design must not leave its picture behind); a project with an empty slot
       is filled from storage. The slot itself only ever holds page 1, which is what the order
       carries; the gallery shows every page. */
    var pages = [];
    var pa = document.querySelector('.c4-apps') && document.getElementById('_printapp');
    if (pa) {
      if (!pa.value) { fillDesignSlot(''); return []; }
      pages = storedPrintAppPages();
      if (!designSlotUrl() && pages.length) fillDesignSlot(pages[0]);
    }
    var slot = designSlotUrl();
    if (!pages.length && slot) pages = pitchPrintPages(slot);
    return pages.filter(function (u) { return probe(u) !== 'bad'; });
  }

  function rasterise(u) {
    if (!CLOUDINARY.test(u) || !RASTERISE.test(u)) return null;
    return u.replace(/\/upload\//i, '/upload/' + DERIVE).replace(RASTERISE, '.jpg$2');
  }

  function uploadPreviews() {
    var out = [], fields = propertyFields();
    for (var i = 0; i < fields.length; i++) {
      if (/printapp/i.test(fields[i].name || '')) continue;
      if (/_c4_design_preview/.test(fields[i].name || '')) continue;
      var parts = (fields[i].value || '').split(',');
      for (var j = 0; j < parts.length; j++) {
        var u = parts[j].trim();
        if (!u || u.indexOf('http') !== 0) continue;
        if (IMGISH.test(u)) {
          if (out.indexOf(u) === -1) out.push(u);
          continue;
        }
        var derived = rasterise(u);
        if (derived && probe(derived) === 'ok' && out.indexOf(derived) === -1) out.push(derived);
      }
    }
    return out;
  }

  function artworkUrls() {
    var out = [];
    var ds = designPreviews();
    for (var d = 0; d < ds.length; d++) {
      var flag = ds.length === 2 ? (d === 0 ? 'Front' : 'Back') : (ds.length > 2 ? 'Page ' + (d + 1) : 'Yours');
      out.push({ url: ds[d], removable: false, flag: flag });
    }
    var ups = uploadPreviews();
    for (var i = 0; i < ups.length; i++) {
      var dupe = out.some(function (o) { return o.url === ups[i]; });
      if (!dupe) out.push({ url: ups[i], removable: true });
    }
    return out;
  }

  function makeThumb(item) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'c4-gallery__thumb c4-gallery__thumb--design';
    btn.setAttribute('data-c4-thumb', '');
    btn.setAttribute('data-c4-design-thumb', '');
    btn.setAttribute('role', 'tab');
    btn.setAttribute('aria-label', 'Your artwork');
    btn.dataset.src = item.url;

    var img = document.createElement('img');
    img.src = item.url;
    img.alt = 'Your artwork for this order';
    img.width = 120;
    img.height = 120;
    img.decoding = 'async';
    btn.appendChild(img);

    var flag = document.createElement('span');
    flag.className = 'c4-gallery__flag';
    flag.textContent = item.flag || 'Yours';
    btn.appendChild(flag);

    if (item.removable) {
      var x = document.createElement('span');
      x.className = 'c4-thumb-x';
      x.setAttribute('role', 'button');
      x.setAttribute('tabindex', '0');
      x.setAttribute('aria-label', 'Remove this file');
      x.title = 'Remove this file';
      x.textContent = '\u00d7';
      var remove = function (e) {
        e.preventDefault();
        e.stopPropagation();
        document.dispatchEvent(new CustomEvent('c4:artwork-remove', { detail: { url: item.url } }));
      };
      x.addEventListener('click', remove);
      x.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') remove(e);
      });
      btn.appendChild(x);
    }
    return btn;
  }

  function syncArtwork() {
    var gallery = document.querySelector('[data-c4-gallery]');
    if (!gallery) return;
    var rail = gallery.querySelector('.c4-gallery__rail');
    var main = gallery.querySelector('[data-c4-main]');
    if (!rail || !main) return;

    var items = artworkUrls();
    var urls = items.map(function (i) { return i.url; });
    var have = Array.prototype.slice.call(rail.querySelectorAll('[data-c4-design-thumb]'));
    var haveUrls = have.map(function (b) { return b.dataset.src; });
    if (urls.join('|') === haveUrls.join('|')) return;

    var wasActive = have.some(function (b) { return b.classList.contains('is-active'); });
    have.forEach(function (b) { b.remove(); });

    if (!items.length) {
      if (wasActive) {
        var first = rail.querySelector('[data-c4-thumb]');
        if (first) first.click();
      }
      return;
    }
    var anchor = rail.firstChild;
    items.forEach(function (i) { rail.insertBefore(makeThumb(i), anchor); });

    /* SHOW WHAT THE CUSTOMER JUST ADDED, not whatever happens to sit first. A saved design and an
       uploaded file are both artwork, and the design sorts first -- so uploading a file used to
       rebuild the rail and then re-select the DESIGN, leaving the new upload sitting in the second
       thumbnail without ever appearing in the main image. Activate the URL that is new to this
       rebuild, and only fall back to the first when nothing is new (a removal, say). */
    var fresh = null;
    var thumbs = rail.querySelectorAll('[data-c4-design-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      /* The FIRST new thumbnail: a two-sided design arrives as two new thumbnails at once, and the
         front is what the customer should see. */
      if (!fresh && haveUrls.indexOf(thumbs[i].dataset.src) === -1) fresh = thumbs[i];
    }
    (fresh || rail.querySelector('[data-c4-design-thumb]')).click();
  }

  function swapText(el, on, replacement) {
    if (!el || !replacement) return;
    if (on) {
      if (!el.dataset.c4Orig) el.dataset.c4Orig = el.textContent;
      if (el.textContent !== replacement) el.textContent = replacement;
    } else if (el.dataset.c4Orig && el.textContent !== el.dataset.c4Orig) {
      el.textContent = el.dataset.c4Orig;
    }
  }

  function bindDesignCard(f, apps, card) {
    if (!card) return;
    var btns = designButtons(f, apps, card);
    var ready = hasDesign();
    var radio = card.querySelector('input[type="radio"]');
    var selected = !!(radio && radio.checked);
    var touched = card.hasAttribute('data-c4-touched');
    var launch = card.querySelector('[data-c4-design-launch]');
    var rm = card.querySelector('[data-c4-design-remove]');

    if (!card.hasAttribute('data-c4-bound')) {
      card.setAttribute('data-c4-bound', '');
      if (launch) {
        launch.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          memo = {};
          var live = designButtons(f, apps, card);
          var go = hasDesign() ? (live.resume || live.create) : (live.create || live.resume);
          if (go) { go.click(); return; }
          var pa = printAppClient();
          if (pa) pa.showApp();
        });
      }
      if (rm) {
        rm.addEventListener('click', function (e) {
          e.preventDefault(); e.stopPropagation();
          memo = {};
          var live = designButtons(f, apps, card);
          if (live.clear) { live.clear.click(); return; }
          var pa = printAppClient();
          if (pa && typeof pa.clearDesign === 'function' && hasDesign()) pa.clearDesign();
        });
      }
    }

    for (var i = 0; i < btns.all.length; i++) setHidden(btns.all[i], true);

    var client = printAppClient();
    var showLaunch = (touched || ready) && selected && (btns.all.length > 0 || !!client);
    if (launch) {
      if (launch.hidden === showLaunch) launch.hidden = !showLaunch;
      var wantLaunch = ready
        ? (card.getAttribute('data-c4-launch-ready') || 'Edit Design')
        : (card.getAttribute('data-c4-launch-idle') || 'Customise');
      if (launch.textContent !== wantLaunch) launch.textContent = wantLaunch;
    }

    var label = card.querySelector('[data-c4-design-label]');
    if (label) {
      var wantLabel = ready
        ? (card.getAttribute('data-c4-label-ready') || 'Design saved')
        : (card.getAttribute('data-c4-label-idle') || '');
      if (wantLabel && label.textContent !== wantLabel) label.textContent = wantLabel;
    }

    swapText(card.querySelector('[data-c4-design-title]'), ready, card.getAttribute('data-c4-title-ready') || 'Design ready');
    swapText(card.querySelector('[data-c4-design-tag]'), ready, card.getAttribute('data-c4-tag-ready') || '');

    if (rm) {
      var showRemove = ready && (!!btns.clear || !!(client && typeof client.clearDesign === 'function'));
      if (rm.hidden === showRemove) rm.hidden = !showRemove;
    }
  }

  function applyLabel(f) {
    if (!hasDesign()) return;
    var matched = false;
    f.querySelectorAll('input[name="properties[Artwork Supplied]"]').forEach(function (r) {
      if (r.value === DESIGN_LABEL) { r.checked = true; matched = true; }
    });
    if (matched) return;
    var hidden = f.querySelector('input[type="hidden"][name="properties[Artwork Supplied]"]');
    if (!hidden) {
      hidden = document.createElement('input');
      hidden.type = 'hidden';
      hidden.name = 'properties[Artwork Supplied]';
      f.appendChild(hidden);
    }
    hidden.value = DESIGN_LABEL;
  }

  function start() {
    var f = form();
    if (!f) return;
    /* LEGACY (product.c4-legacy): Apippa and PitchPrint are store-level scripts, so the form has
       no .c4-apps block. Everything vendor-specific below is gated on `apps`; what still applies
       is the shared work -- artwork thumbnails in the gallery and the mobile sticky bar. */
    var apps = f.querySelector('.c4-apps');
    var legacy = f.hasAttribute('data-c4-legacy');
    if (!apps && !legacy) return;
    if (getComputedStyle(f).position === 'static') f.style.position = 'relative';
    injectVendorStyles();

    /* Pair token for the artwork-plan line (proof stage: written, not yet used). One per page view. */
    var pair = f.querySelector('[data-c4-pair]');
    if (pair && !pair.value) {
      pair.value = 'c4p_' + (window.crypto && crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2, 10));
    }

    var busy = false;
    var queued = 0;
    var wait = QUICK_MS;
    var calm = 0;
    var lastSig = '';
    var timer = 0;

    function signature() {
      var t = apps ? vendorTotal(apps) : null;
      var p = (projectId() || '') + '|' + (designSlotUrl() || '');
      var plan = pendingPlan();
      var vendorAdd = apps && vendorAddButton(f, apps) ? '1' : '0';
      var props = propertyFields().map(function (i) { return i.name + '=' + i.value; }).join(';');
      return (t ? t.text : '') + '|' + p + '|' + vendorAdd + '|' + (plan ? plan.id : '') + '|' + props;
    }

    function run() {
      queued = 0;
      if (busy) return;
      busy = true;
      memo = {};
      try {
        var card = f.querySelector('[data-c4-design-card]');
        if (apps) {
          sweep(f, apps);
          syncPrice(apps);
          syncTotalBar(apps);
          bindBottomAdd(f, apps);
          bindDesignCard(f, apps, card);
          applyLabel(f);
        }
        syncSticky(f);
        syncArtwork();

        var sig = signature();
        if (sig === lastSig) {
          calm++;
          if (calm >= CALM_TICKS) wait = Math.min(wait * 2, IDLE_MAX_MS);
        } else {
          lastSig = sig;
          calm = 0;
          wait = QUICK_MS;
        }
      } finally {
        memo = {};
        requestAnimationFrame(function () { busy = false; });
      }
      schedule();
    }

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        if (document.hidden) { schedule(); return; }
        tick();
      }, wait);
    }

    function tick() {
      if (queued) return;
      queued = requestAnimationFrame(run);
    }

    function wake() {
      wait = QUICK_MS;
      calm = 0;
      tick();
    }

    onProbe = wake;
    if (apps) { guardPrintAppMessages(); hookPrintAppSaved(wake); }
    run();

    var art = f.querySelector('.c4-art');
    if (art) {
      art.addEventListener('click', function (e) {
        if (e.target.closest('[data-c4-design-launch]') || e.target.closest('[data-c4-design-remove]')) return;
        var card = f.querySelector('[data-c4-design-card]');
        if (!card) return;
        if (e.target.closest('[data-c4-design-card]')) card.setAttribute('data-c4-touched', '');
        wake();
      });
    }

    new MutationObserver(wake).observe(f, {
      childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'value', 'checked']
    });
    f.addEventListener('change', wake);
    document.addEventListener('c4:artwork-remove', function () { setTimeout(wake, 60); });
    document.addEventListener('c4:plan-chosen', wake);

    window.addEventListener('focus', wake);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) wake(); });
    window.addEventListener('message', function (e) {
      if (e.origin && VENDOR_HOST.test(e.origin)) setTimeout(wake, 60);
    });
    window.addEventListener('resize', wake);
    f.addEventListener('submit', function () { memo = {}; applyLabel(f); }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
